import { Component, Input, OnInit } from '@angular/core';
import { ContentfulService } from '../../_services/contentful.service';
import { Observable, from } from 'rxjs';
import { LandingPage, FavIcon } from '../../_models/landing-page.model';
import { FormFlow } from '../../_models/form-dynamic.model';
import { Header } from '../../_models/header.model';
import { Footer } from '../../_models/footer.model';
import { Theme, ColorPicker } from '../../_models/theme.model';
import { Asset, Entry } from 'contentful';
import { environment } from '../../../enviroments/environment';
import { Renderer2 } from '@angular/core';
import { ContentfulLivePreview, ContentfulLivePreviewInitConfig } from '@contentful/live-preview';
import { Article } from '../../_models/article.model';
import { MetaTagsManagementService } from '../../_services/meta-tags-management.service';
import { Title } from '@angular/platform-browser';
import { WindowService } from '../../_services/window.service';



@Component({
  selector: 'app-landing-page-v2',
  standalone: false,
  templateUrl: './landing-page-v2.component.html',
  styleUrl: './landing-page-v2.component.css'
})
export class LandingPageV2Component implements OnInit {
  @Input() landingPageID: string | null = "";
  @Input() landingPageTypeID: string | null = "";



  landingData: any = {};
  isLoading = true;
  error = false;

  landingPage: Entry<LandingPage> | undefined;
  title: string = "";
  favIcon: Entry<FavIcon> | undefined;
  headerContent: Entry<Header> | undefined
  formFlowConfig: Entry<FormFlow> | undefined;
  articlesConfig: Array<Entry<Article>> | undefined;
  footerContent: Entry<Footer> | undefined;
  themeContent: Entry<Theme> | undefined

  constructor(
    private contentful: ContentfulService,
    private renderer: Renderer2,
    private metaTagsManagementService: MetaTagsManagementService,
    private windowService: WindowService
  ) { }

  ngOnInit() {

    this.loadLandingData(this.landingPageID);

  }

  private loadLandingData(landingPageID: string | null) {
    from(this.contentful.getLandingPage(landingPageID)).subscribe({
      next: (page: Entry<LandingPage>) => {
        this.landingPage = page as Entry<LandingPage>;
        this.title = page.fields.title as any as string;
        this.favIcon = page.fields.favIcon as unknown as Entry<FavIcon>
        this.headerContent = page.fields.header as unknown as Entry<Header>;
        this.formFlowConfig = page.fields.form as unknown as Entry<FormFlow>;        
        this.articlesConfig = page.fields.articles as unknown as Array<Entry<Article>>;
        this.footerContent = page.fields.footer as unknown as Entry<Footer>;
        this.themeContent = page.fields.theme as unknown as Entry<Theme>;
  

        this.isLoading = false;

        if(this.favIcon) {
          this.manageFavIcon(this.favIcon);
        }
        if(this.themeContent) {
          this.manageTheme(this.themeContent);
        }
        
        this.metaTagsManagementService.setSeoData(
          {
            title: this.title,
            description: this.title
          }
        )
        
            
      },
      error: (err) => {
        console.error('Error:', err);
        this.isLoading = false;
      }
    });
  }

  manageTheme(theme: Entry<Theme>) {
    const doc = this.windowService.document;
    if (!doc) {
      return;
    }

    //const appMain = document.getElementById('app-main'); //JLFranco
    const appMain = doc.getElementById('app-main');
    if (!appMain) return;

    this.renderer.removeClass(appMain, 'theme-default');
    this.renderer.addClass(appMain, theme.fields.className.toString());

    //const element = document.querySelector(`.${theme.fields.className}`) as HTMLElement; //JLFranco
    const element = doc.querySelector(`.${theme.fields.className}`) as HTMLElement;
    if (!element) return;

    const themeConfig = {
      '--title-color': theme.fields.titleColor?.['value'],
      '--subtitle-color': theme.fields.subTitleColor?.['value'],
      '--element-color-primary': theme.fields.elementsColor1?.['value'],
      '--buttons-color-primary': theme.fields.buttonsColor1?.['value'],
      '--text-color': theme.fields.textColor1?.['value'],
      '--footer-text-color': theme.fields.footerTextColor?.['value'],
    };


    const sizeThemeConfig = {
      '--title-size': (theme.fields.titleFontSizePercentage?.toString()),
      '--subtitle-size': (theme.fields.subtitleFontSize?.toString()),
    }

    Object.entries(themeConfig).forEach(([prop, value]) => {
      //const currentValue = getComputedStyle(element).getPropertyValue(prop); //JLFranco
      const currentValue = this.windowService.getComputedStyle(element)?.getPropertyValue(prop) || '';
      element.style.setProperty(prop, value || currentValue);
    });

    Object.entries(sizeThemeConfig).forEach(([prop, value]) => {
      //const currentValue = getComputedStyle(element).getPropertyValue(prop); //JLFranco
      const currentValue = this.windowService.getComputedStyle(element)?.getPropertyValue(prop) || '';
      element.style.removeProperty(prop);
      element.style.setProperty(prop, (value ? value.toString() + '%' : null) || currentValue);
    });

    if(theme.fields.fontFamily) {
      //document.querySelector('body')?.style.setProperty('font-family', theme.fields.fontFamily.toString()) //JLFranco
      doc.querySelector('body')?.style.setProperty('font-family', theme.fields.fontFamily.toString())
    }

  }

  manageFavIcon(favIcon: Entry<FavIcon>) {
    const doc = this.windowService.document;
    if (!doc) {
      return;
    }

    //var _favIcon = document.querySelector('link[rel*=icon]') as HTMLLinkElement; //JLFranco
    var _favIcon = doc.querySelector('link[rel*=icon]') as HTMLLinkElement;

    var favIconAsset = favIcon.fields.file
    if (favIconAsset['url']) {
      _favIcon.href = favIconAsset['url']
    }
  }


}
